import styled from 'styled-components';
import { Grid } from '@material-ui/core';

import { fontFamilySize, colors, px } from '../../../../contrib/ui';

export const ClubPendingInvitationsRowStyled = styled(Grid)`
  height: 100%;
  padding-left: ${px(15)};
  padding-right: ${px(15)};
  ${fontFamilySize('Heavy', 16)}
  line-height: ${px(50)};
  height: ${px(50)};
  border-bottom: 1px solid ${colors.greydd};

  .copy-widget-cta{
    color: ${colors.red};
  }
`;

export const ClubPendingInvitationsHeaderStyled = styled(ClubPendingInvitationsRowStyled)`
  background-color: ${colors.dark};
  color: #fff;
`;
